<template>
    <el-container v-loading="loading" class="post-article">
        <el-header class="header">
            <el-select v-model="article.pid" placeholder="请选择产品分类" style="width: 150px;">
                <el-option v-for="item in categories" :key="item.id" :label="item.productName" :value="item.id"></el-option>
            </el-select>
            <el-input v-model="article.title" placeholder="请输入标题..." style="width: 400px;margin-left: 10px"></el-input>
        </el-header>
        <el-main class="main">
            <div id="editor">
                <mavon-editor style="height: 100%;width: 100%;" ref="md" @imgAdd="imgAdd" @imgDel="imgDel" v-model="article.mdContent"></mavon-editor>
            </div>
            <div style="display: flex;align-items: center;margin-top: 15px;justify-content: flex-end">
                <el-button @click="cancelEdit" v-if="isStatus == 1">放弃修改</el-button>
                <template v-if="isStatus == 0">
                    <el-button type="primary" @click="saveProductDetail()">添加参数</el-button>
                </template>
                <template v-else>
                    <el-button type="primary" @click="saveProductDetail()">更新参数</el-button>
                </template>
            </div>
        </el-main>
    </el-container>
</template>
<script>
import { postRequest, putRequest, getRequest, uploadFileRequest, isNotNullORBlank } from '@/utils/api';
// Local Registration
import { mavonEditor } from 'mavon-editor';
// 可以通过 mavonEditor.markdownIt 获取解析器markdown-it对象
import 'mavon-editor/dist/css/index.css';

export default {
    mounted: function() {
        const { lid, pid, isStatus } = this.$route.query;
        if (lid && pid) {
            this.article.pid = pid;
            this.article.lid = lid;
            this.isStatus = isStatus;
            if (Number(isStatus) === 1) {
                this.getProductDetail(lid);
            }
        }
        this.getProductCategory();
    },
    components: {
        mavonEditor,
    },
    methods: {
        getProductCategory() {
            getRequest('/product/category/all').then(result => {
                const { code, message, data } = result.data;
                if (code === 200) {
                    this.categories = data;
                } else {
                    this.tipInfo('error', '信息错误');
                }
            });
        },
        getProductDetail(lid) {
            this.loading = true;
            postRequest('/productDetail/find', { lid })
                .then(result => {
                    this.loading = false;
                    const { code, message, data } = result.data;
                    if (code === 200) {
                        this.article = data;
                        this.tipInfo('success', message);
                    } else {
                        this.tipInfo('error', '页面加载失败!');
                    }
                })
                .catch(() => {
                    this.tipInfo('error', '检查网络错误或服务器是否响应!');
                });
        },
        cancelEdit() {
            this.$router.go(-1);
        },
        saveProductDetail() {
            const { title, mdContent, pid } = this.article;
            if (title === '' || title === null) {
                return this.tipInfo('error', '标题不得为空!');
            }
            if (mdContent === '' || mdContent === null) {
                return this.tipInfo('error', '内容不得为空!');
            }
            if (pid === '' || pid === null) {
                return this.tipInfo('error', '产品类型为空!');
            }
            this.loading = true;
            this.getCurrentUser();
        },
        getCurrentUser() {
            getRequest('/currentUserName').then(msg => {
                const { data, status } = msg;
                if (status === 200) {
                    this.uploadProductDetail(data);
                }
            });
        },
        uploadProductDetail(nickName) {
            const { title, mdContent, pid, lid } = this.article;
            const category = this.categories.find(value => value.id === pid).productName;
            if (this.isStatus == 1) {
                const { id, nickname, cateName } = this.article;
                postRequest('/productDetail/update', {
                    id,
                    title,
                    mdContent,
                    htmlContent: this.$refs.md.d_render,
                    pid,
                    lid,
                    nickname: nickName,
                    cateName,
                })
                    .then(result => {
                        this.loading = false;
                        const { code, message } = result.data;
                        if (code == 200) {
                            this.cancelEdit();
                            this.tipInfo('success', '更新成功');
                        } else {
                            this.tipInfo('error', '更新失败');
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.tipInfo('error', '服务器错误');
                    });
            } else {
                postRequest('/productDetail/add', {
                    title,
                    mdContent,
                    htmlContent: this.$refs.md.d_render,
                    pid,
                    lid,
                    nickname: nickName,
                    cateName: category,
                })
                    .then(result => {
                        this.loading = false;
                        const { code, message } = result.data;
                        if (code == 200) {
                            this.cancelEdit();
                            this.tipInfo('success', '添加成功');
                        } else {
                            this.tipInfo('error', '添加失败');
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.tipInfo('error', '服务器错误');
                    });
            }
        },
        imgAdd(pos, $file) {
            // 第一步.将图片上传到服务器.
            let formdata = new FormData();
            formdata.append('image', $file);
            uploadFileRequest('/uploadimg', formdata).then(resp => {
                const { data, code } = resp.data;
                if (code === 200) {
                    this.img_file[pos] = data;
                    this.$refs.md.$imglst2Url([[pos, data]]);
                } else {
                    this.$message({
                        type: 'error',
                        message: '上传失败',
                    });
                }
            });
        },
        imgDel(pos) {
            const key = this.img_file[pos];
            if (key) {
                const path = key.slice(key.lastIndexOf('/') + 1, key.length);
                postRequest('/deleteimg', { filename: path }).then(res => {
                    const { code } = res.data;
                    if (code === 200) {
                        this.tipInfo('succcess', '图片删除成功');
                    }
                });
            }
        },
        tipInfo(type = 'error', message) {
            this.$message({ type: type, message: message });
        },
    },
    data() {
        return {
            img_file: [],
            categories: [],
            loading: false,
            isStatus: '',
            from: '',
            article: {
                title: '',
                mdContent: '',
                pid: '',
                lid: '',
                nickName: '',
                cateName: '',
            },
        };
    },
};
</script>
<style>
.post-article > .main > #editor {
    width: 100%;
    height: 450px;
    text-align: left;
}

.post-article > .header {
    background-color: #ececec;
    margin-top: 10px;
    padding-left: 5px;
    display: flex;
    justify-content: flex-start;
}

.post-article > .main {
    /*justify-content: flex-start;*/
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    background-color: #ececec;
    padding-top: 0px;
}

.post-article > .header > .el-tag + .el-tag {
    margin-left: 10px;
}

.post-article > .header > .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.post-article > .header > .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/editProductDetail.vue